// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2n6mH","signatureButtonsRight":"ModalSign_signatureButtonsRight__37wTJ"};